/**
 * Hook that determines if work order flow is enabled for the current machine.
 *
 * Work order flow requires:
 * - Work order flow to be enabled in company settings
 * - Machine to be mapped to ERP resources (direct or via machine groups)
 *
 * This enables operators to work with ERP-driven work orders and operations.
 */
import { useSelector } from 'react-redux';
import { getIsWorkOrderFlowEnabled } from 'lib/selectors/getIsWorkOrderFlowEnabled';

const useIsWorkOrderFlow = () => {
  const isWorkOrderFlowEnabled = useSelector(getIsWorkOrderFlowEnabled);
  return isWorkOrderFlowEnabled;
};

export { useIsWorkOrderFlow };
